<template>
    <form-group
        :horizontal="horizontal"
        :label="label"
        :label-classes="labelClasses"
    >
        <div
            v-for="option in options"
            :key="option.value"
            :class="{ 'is-invalid': !!invalidFeedback }"
            class="form-check"
        >
            <label class="form-label form-check-label clickable"
                ><input
                    :checked="option.value === modelValue"
                    :class="{ 'is-invalid': !!invalidFeedback }"
                    :value="option.value"
                    class="form-check-input"
                    type="radio"
                    @input="$emit('update:modelValue', option.value)"
                />
                {{ option.label }}</label
            ><!---->
            <!---->
        </div>
        <div
            v-if="!!invalidFeedback"
            class="invalid-feedback"
            v-text="invalidFeedback"
        />
    </form-group>
</template>
<script setup>
import FormGroup from '@/Components/FormGroup.vue';

const props = defineProps({
    options: { type: Array },
    modelValue: { type: String },
    horizontal: { type: [Boolean, Object, null] },
    label: { type: String },
    labelClasses: { type: [Object, Array, String] },
    invalidFeedback: { type: String },
});
</script>
